export default {
  create: 'Crear Simulación de Presupuesto',
  createFromScratch: 'Desde cero',
  createLastYearFree: 'Último Año, Libre',
  createLastYearFrozen: 'Último Año, Fijo',
  createNextYearFree: 'Próximo Año, Libre',
  chooseSubtitle: 'Empieza con una simulación en blanco o deja que una plantilla complete el período y el presupuesto por ti.',
  chooseFromScratchDescription: 'Define tú el período, el presupuesto de referencia y el modo de mix.',
  chooseLastYearFreeTitle: 'Año Anterior, Mix Libre',
  chooseLastYearFreeDescription: 'Los últimos 12 meses de datos, con el optimizador eligiendo el mejor mix para cada presupuesto.',
  chooseLastYearFrozenTitle: 'Año Anterior, Mix Fijo',
  chooseLastYearFrozenDescription: 'Los últimos 12 meses de datos, con cada presupuesto manteniendo el mix histórico de canales de ese período.',
  chooseNextYearFreeTitle: 'Próximo Año, Mix Libre',
  chooseNextYearFreeDescription: 'El presupuesto que el modelo propaga para el próximo año, con el optimizador eligiendo el mejor mix para cada presupuesto.',
  chooseTagStrategyCheck: 'Strategy Check',
  chooseTagForwardLooking: 'Forward Looking',
  createFlexibleDates: 'Fechas Flexibles',
  chooseFlexibleTitle: 'Fechas Flexibles',
  chooseTagFlexible: 'Flexible',
  flexibleSummaryActual: 'Inversión real',
  flexibleSummaryPropagation: 'Propagación de presupuesto',
  flexibleSummaryEmpty: 'Sin datos, suma 0',
  flexibleMonths: '{count} mes | {count} meses',
  flexibleWeeks: '{count} semana | {count} semanas',
  flexibleHintActual: 'Hay inversión real disponible hasta {date}.',
  flexibleHintPropagation: 'La propagación de presupuesto cubre de {from} a {to}.',
  chooseFlexibleDescription: 'Elige cualquier período: su presupuesto de referencia y su mix Fijo suman la inversión real donde el modelo la tiene y la propagación de presupuesto después.',
  flexibleSummaryTotal: 'Presupuesto de referencia',
  flexibleHintMix: 'La simulación empieza con mix Libre, que puedes cambiar a Fijo en el siguiente paso.',
  chooseNeedsMediaSpend: 'Requiere datos de inversión en medios en el reporte del modelo',
  chooseNeedsBudgetPropagation: 'Requiere datos de propagación de presupuesto en el reporte del modelo',
  loading: 'Cargando simulaciones de presupuesto...',
  noSimulations: 'Aún no hay simulaciones de presupuesto',
  search: 'Buscar',
  ready: 'Lista',
  running: 'Calculando... {done}/{total}',
  headerName: 'Nombre',
  headerMixMode: 'Modo del Mix',
  headerPeriod: 'Periodo',
  headerProgress: 'Estado',
  headerCreated: 'Creada',
  copy: 'copia',
  gridRange: '{from}%–{to}% · {count} presupuestos',
  headerReferenceBudget: 'Presupuesto de Referencia ({unit})',
  sharedWithExternalUsers: 'Compartida con usuarios externos'
}
